import { Box, SvgIcon } from '@material-ui/core';
import React, { Component, Fragment, MouseEventHandler } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { AppState } from 'store';
import { IContentState } from 'store/content/content.interface';
import { getContentSelector } from 'store/content/content.selectors';
import FilterPopper from './FilterPopper';
import { FilterButton } from './FilterStyles';

interface IStateProps {
  contentState: IContentState;
}

interface IState {
  anchorEl?: HTMLElement;
  popperId: string;
}

type PropType = WithTranslation & IStateProps;

export class AddManyContentsFilter extends Component<PropType, IState> {
  constructor(props: PropType) {
    super(props);

    this.state = {
      anchorEl: undefined,
      popperId: 'add-many-contents-filter-popper',
    };
  }

  handleClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    const { anchorEl } = this.state;

    this.setState({
      anchorEl: anchorEl ? undefined : event.currentTarget,
    });
  };

  handleClose = (): void => {
    const { anchorEl } = this.state;

    setTimeout(() => {
      if (anchorEl) {
        this.setState({ anchorEl: undefined });
      }
    }, 1);
  };

  render(): JSX.Element {
    const {
      t,
      contentState: { isFiltered },
    } = this.props;
    const { anchorEl, popperId } = this.state;

    return (
      <Fragment>
        <FilterButton
          opened={Number(!!anchorEl)}
          filtered={Number(isFiltered)}
          onClick={this.handleClick}
          startIcon={
            <SvgIcon>
              <path d="M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6c0,0,3.72-4.8,5.74-7.39 C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z" />
            </SvgIcon>
          }
        >
          <Box fontWeight="500">{t('common.filter')}</Box>
        </FilterButton>
        <FilterPopper id={popperId} anchorEl={anchorEl} handleClose={this.handleClose} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state: AppState): IStateProps => ({
  contentState: getContentSelector(state),
});

export default connect(mapStateToProps)(withTranslation()(AddManyContentsFilter));
